import React from 'react'

const FaqPage = () =>
  <div className="page">
    FAQ
  </div>

export default FaqPage
